import script from "./dpc-language-selector-selector.vue?vue&type=script&setup=true&lang=js"
export * from "./dpc-language-selector-selector.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__